import { Typography } from "@material-ui/core"

const Unhappy = (props) => {

  return ( <>
    <Typography>
      We get it—music is personal, and sometimes a song just doesn’t hit the right note. If you love the lyrics but want a different version of the song, we’ll give you a <b>30% discount</b> to have it re-recorded in a new style. If you want to tweak the lyrics and start fresh, we’ll give you a <b>10% discount</b> to go back to the drawing board. Either way, we’ll make sure you get a song you’re happy with—no sad trombones here! 
    </Typography>
  </> )
}

export default Unhappy
